// Catalog copy/availability boundary: erg-dbk-catalog-public-source-003.
// Indexing this informational page does not attest customer enablement.
export const dbk_usServicesMetadata = {
  path: "/us/services",
  canonicalUrl: "https://dynamicbooks.app/us/services",
  title: "Explore Our Accounting & AI Agent Services | DynamicBooks",
  description: "Explore accounting workflows, review responsibilities and workspace locations. Customer availability requires confirmation.",
  keywords: "US accounting workflows, AI agent services, accounting review, DynamicBooks",
  imagePath: "/assets/us-homepage/dynamicbooks-us-homepage-social-1200x630.png",
  imageAlt: "DynamicBooks workflow from accounting records through agent preparation and human review to structured reporting.",
  imageWidth: "1200",
  imageHeight: "630",
  imageType: "image/png"
} as const;

export function dbk_buildUsServicesMetadata(origin: string | null = null) {
  const hostname = origin ? new URL(origin).hostname.toLowerCase() : "";
  const robots = hostname === "dynamicbooks.app" || hostname === "www.dynamicbooks.app"
    ? "index,follow" as const : "noindex,nofollow" as const;
  const { canonicalUrl, title, description } = dbk_usServicesMetadata;
  return {
    ...dbk_usServicesMetadata,
    robots,
    imageUrl: new URL(dbk_usServicesMetadata.imagePath, canonicalUrl).toString(),
    jsonLd: {
      "@context": "https://schema.org" as const,
      "@graph": [{
        "@type": "WebPage",
        "@id": `${canonicalUrl}#webpage`,
        name: title,
        description,
        url: canonicalUrl,
        inLanguage: "en-US"
      }]
    }
  };
}
